import { Flex, Text, Heading } from '@synqly/ui/radix/themes'

export { ErrorPage, getInitialProps }

ErrorPage.getInitialProps = getInitialProps

/**
 * @param {{
 *   statusCode: number
 *   message: string
 *   children: import('react').ReactNode
 * }} props
 */
function ErrorPage({
  statusCode,
  message = StandardMessage[statusCode],
  children,
}) {
  return (
    <Flex align="center" direction="column" gap="4" justify="center">
      <Heading size="8">{statusCode}</Heading>
      {!!message && <Text weight="medium">{message}</Text>}
      {children}
    </Flex>
  )
}

async function getInitialProps({ res, err }) {
  let body

  try {
    body = (await res.json()) ?? err
  } catch {
    // Response body not strictly necessary, so ignoring parse errors
  }

  const statusCode = res?.statusCode ?? err?.statusCode ?? 404
  return {
    statusCode,
    message: body?.message ?? err?.message ?? StandardMessage[statusCode],
  }
}

const StandardMessage = {
  400: 'Bad Request',
  404: 'Not Found',
}
